'use client';

import Image from 'next/image';
import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FeatureHero from '../_shared/sections/FeatureHero';

type Props = { lang: Locale };

const DISCOVER_BC_IMAGE = 'https://cdn.1cdn.app/application/UMD/26050508333575_bc_sum_sample.png';

const DiscoverBcHero = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const visual = (
    <Image
      src={DISCOVER_BC_IMAGE}
      alt={t('DiscoverBc/Hero/visual_alt')}
      width={840}
      height={840}
      sizes="(min-width: 1024px) 256px, 50vw"
      className="mx-auto h-auto w-1/2 max-w-[240px] rounded-3xl lg:w-4/5"
      priority
    />
  );

  return (
    <FeatureHero
      accent="#A78BFA"
      ariaLabel={t('DiscoverBc/Hero/aria_label')}
      copy={{
        kicker: t('DiscoverBc/Hero/badge'),
        headlineA: t('DiscoverBc/Hero/title1'),
        headlineB: t('DiscoverBc/Hero/title2'),
        subhead: t('DiscoverBc/Hero/subtitle'),
        ctaPrimary: {
          label: t('DiscoverBc/Hero/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('DiscoverBc/Hero/cta_secondary'),
          href: `/${lang}/business-cards`,
        },
      }}
      visual={visual}
      visualVisibleOnMobile
    />
  );
};

export default DiscoverBcHero;
